"use client";

import { useTranslations } from "next-intl";
import { useModalInquiryContext } from "@/context/ModalInquiryContext";

// 内联 SVG 图标组件
const UploadIcon = ({ className }: { className?: string }) => (
	<svg viewBox="0 0 64 64" className={className}>
		<circle fill="#FBFBFB" cx="32" cy="32" r="32" />
		<path
			fill="#FFFFFF"
			d="M64,32c0,8.49-3.37,16.63-9.37,22.63c-6,6-14.14,9.37-22.63,9.37s-16.63-3.37-22.63-9.37C3.37,48.63,0,40.49,0,32h32H64z"
		/>
		<path
			fill="#0F7E03"
			d="M15,44V15c0-0.55,0.45-1,1-1h7.73c0.25,0,0.5,0.1,0.68,0.27l4.26,3.99c0.19,0.17,0.43,0.27,0.68,0.27H48c0.55,0,1,0.45,1,1V44c0,0.55-0.45,1-1,1H16C15.45,45,15,44.55,15,44z"
		/>
		<path
			fill="#65A525"
			d="M12.18,27.16c-0.1-0.61,0.37-1.16,0.99-1.16h37.66c0.61,0,1.08,0.55,0.99,1.16l-2.68,17c-0.08,0.49-0.5,0.84-0.99,0.84H15.85c-0.49,0-0.91-0.36-0.99-0.84L12.18,27.16z"
		/>
	</svg>
);

const QuoteIcon = ({ className }: { className?: string }) => (
	<svg viewBox="0 0 64 64" className={className}>
		<circle fill="#FBFBFB" cx="32" cy="32" r="32" />
		<path
			fill="#FFFFFF"
			d="M64,32c0,8.49-3.37,16.63-9.37,22.63c-6,6-14.14,9.37-22.63,9.37s-16.63-3.37-22.63-9.37C3.37,48.63,0,40.49,0,32h32H64z"
		/>
		<path
			fill="#65A525"
			d="M21.32,24.48v22.43c0,2.27-1.87,4.13-4.16,4.13c-2.29,0-4.16-1.86-4.16-4.13V24.48H21.32z"
		/>
		<path
			fill="#0F7E03"
			d="M50,17.09v29.85c0,2.24-1.87,4.09-4.21,4.09H16.46c2.34,0,4.25-1.86,4.25-4.13V17.09c0-2.27,1.87-4.09,4.17-4.09h20.92C48.13,13,50,14.82,50,17.09z"
		/>
		<path fill="#FFFFFF" d="M45.54,33.42H25.55v2.35h19.99V33.42z" />
		<path fill="#FFFFFF" d="M39.74,37.66H25.55v2.35h14.19V37.66z" />
		<path
			fill="#FFFFFF"
			d="M31.96,26.45c0,0.57-0.23,1.06-0.69,1.48c-0.46,0.42-1.03,0.64-1.72,0.72v0.76h-0.65v-0.76c-0.69-0.08-1.26-0.3-1.72-0.76c-0.46-0.42-0.69-0.95-0.69-1.55h1.07c0,0.34,0.11,0.64,0.38,0.87c0.27,0.27,0.57,0.42,0.95,0.45v-2.69c-1.53-0.34-2.29-1.1-2.29-2.27c0-0.57,0.23-1.02,0.65-1.44c0.42-0.42,0.95-0.61,1.64-0.68v-0.76h0.65v0.76c0.65,0.08,1.18,0.3,1.64,0.72c0.42,0.42,0.65,0.91,0.65,1.48h-1.07c0-0.3-0.11-0.57-0.34-0.8c-0.23-0.23-0.5-0.38-0.84-0.45v2.54C31.16,24.48,31.96,25.27,31.96,26.45z M27.72,22.66c0,0.57,0.38,0.99,1.18,1.25v-2.35c-0.34,0.04-0.65,0.19-0.84,0.38C27.84,22.17,27.72,22.4,27.72,22.66z M29.55,27.7c0.38-0.04,0.69-0.19,0.95-0.42c0.23-0.23,0.38-0.45,0.38-0.76c0-0.61-0.42-1.02-1.3-1.33v2.5H29.55z"
		/>
	</svg>
);

const ReceiveIcon = ({ className }: { className?: string }) => (
	<svg viewBox="0 0 64 64" className={className}>
		<circle fill="#FBFBFB" cx="32" cy="32" r="32" />
		<path
			fill="#FFFFFF"
			d="M64,32c0,8.49-3.37,16.63-9.37,22.63c-6,6-14.14,9.37-22.63,9.37s-16.63-3.37-22.63-9.37C3.37,48.63,0,40.49,0,32h32H64z"
		/>
		<path
			fill="#0F7E03"
			d="M50.75,22.32l-16.1-10.05c-0.23-0.15-0.52-0.19-0.77-0.11l-4.29,1.23l-6.61,1.9L12.8,18.19c-0.4,0.13-0.69,0.5-0.69,0.92v21.04c0,0.54,0.27,1.01,0.73,1.3l15.55,9.73c0.46,0.29,1.01,0.36,1.55,0.21l19.97-5.73c0.82-0.23,1.38-0.98,1.38-1.84V23.3C51.29,22.92,51.08,22.53,50.75,22.32z M29.11,49.86l-15.53-9.71V20.96l12.02,7.51l1.7,1.07l1.8,1.13V49.86z M29.13,29.02l-15.22-9.52l9.08-2.6l6.61-1.9l4.83-1.38l15.22,9.52L29.13,29.02z"
		/>
		<path
			fill="#FFFFFF"
			d="M49.64,23.15l-5.97,1.7v7.64l-2.89-1.09L37.04,34v-7.26l-7.91,2.28h-0.02l-15.2-9.52l20.51-5.88L49.64,23.15z"
		/>
		<path fill="#65A525" d="M29.12,30.67v19.19l-15.53-9.71V20.96l12.02,7.53l1.7,1.05L29.12,30.67z" />
		<path
			fill="none"
			stroke="#D9D9D9"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M31.42,47.17l4.73-1.89"
		/>
		<path
			fill="none"
			stroke="#D9D9D9"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M31.42,45.27l4.73-1.89"
		/>
	</svg>
);

// SVG 图标组件映射
const IconMap = {
	upload: UploadIcon,
	quote: QuoteIcon,
	receive: ReceiveIcon,
};

// 步骤数据配置 - 简化为3个步骤
const stepsData: {
	id: "upload" | "quote" | "receive";
	titleKey: string;
	descKey: string;
}[] = [
	{
		id: "upload",
		titleKey: "uploadTitle",
		descKey: "uploadDesc",
	},
	{
		id: "quote",
		titleKey: "quoteTitle",
		descKey: "quoteDesc",
	},
	{
		id: "receive",
		titleKey: "receiveTitle",
		descKey: "receiveDesc",
	},
];

// 步骤卡片组件
function StepCard({
	step,
	t,
	index,
}: {
	step: (typeof stepsData)[0];
	t: (key: string) => string;
	index: number;
}) {
	const IconComponent = IconMap[step.id];

	return (
		<article className="flex h-full flex-col rounded-lg bg-[#f3f3f3] px-4 py-8 transition-all duration-300 hover:bg-[#eef3f6] sm:px-5 sm:py-10 md:px-6 md:py-12 lg:py-[70px]">
			{/* 步骤编号和图标 */}
			<div className="mb-4 sm:mb-5 md:mb-6 lg:mb-[30px]">
				<IconComponent className="h-12 w-12 sm:h-14 sm:w-14 md:h-[56px] md:w-[56px] lg:h-[60px] lg:w-[60px]" />
			</div>

			{/* 标题 */}
			<h3 className="mb-2 text-lg font-semibold text-black sm:mb-3 sm:text-xl md:text-2xl lg:text-[26px]">
				{t(step.titleKey)}
			</h3>

			{/* 描述 */}
			<p className="text-sm leading-relaxed text-gray-900 sm:text-base">{t(step.descKey)}</p>
		</article>
	);
}

export default function HowToOrder() {
	const t = useTranslations("howToOrder");
	const tBase = useTranslations("base");
	const { openModalInquiry } = useModalInquiryContext();

	return (
		<section className="bg-white py-12 sm:py-16">
			<div className="container">
				{/* 标题区域 */}
				<div className="mx-auto mb-10 text-center sm:mb-12 md:mb-14 lg:mb-16">
					<h2 className="text-2xl font-bold leading-tight text-gray-900 sm:text-3xl md:text-4xl lg:text-[42px]">
						{t("title")}
					</h2>
				</div>

				{/* 步骤卡片网格 - 3列布局 */}
				<div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
					{stepsData.map((step, index) => (
						<StepCard key={step.id} step={step} t={t} index={index} />
					))}
				</div>

				{/* 底部按钮 - 点击弹出询盘弹窗 */}
				<div className="mt-10 text-center sm:mt-12 md:mt-14">
					<button
						type="button"
						onClick={openModalInquiry}
						className="group inline-flex w-full items-center justify-center gap-2 rounded bg-themePrimary400 px-4 py-2.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-opacity-80 hover:text-white sm:w-fit sm:px-5 sm:py-3 md:px-10 md:py-3.5 md:text-base"
					>
						{t("ctaButton")}
					</button>
				</div>
			</div>
		</section>
	);
}
